import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const AuthBackground = styled(Box)(({ theme }) => ({
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: `linear-gradient(45deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
  padding: theme.spacing(3),
}));

const AuthCard = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  padding: theme.spacing(4),
  width: '100%',
  maxWidth: 450,
  boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
}));

function AuthLayout() {
  return (
    <AuthBackground>
      <Container maxWidth="sm">
        <AuthCard elevation={0}>
          <Outlet />
        </AuthCard>
      </Container>
    </AuthBackground>
  );
}

export default AuthLayout; 